<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    v-model="showModal"
    @ok="onStore"
  >
    <form
      @submit.stop.prevent="onStore"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-row>
        <b-col>
          <label tag="div">Método de pagamento</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.tp_pagamento"
              :options="optionsTpPagamento"
              name="tp_pagamento"
              plain
              value-field="value"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            v-text="form.errors.get('tp_pagamento')"
            v-if="form.errors.has('tp_pagamento')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row v-show="this.form.tp_pagamento == 2">
        <b-col>
          <label tag="div">Cartao </label>
          <b-form-input
            type="text"
            placeholder="N° Cartão"
            v-model="form.num_cartao"
            name="nome"
          >
          </b-form-input>
          <b-form-feedback
            v-text="form.errors.get('num_cartao')"
            v-if="form.errors.has('num_cartao')"
          ></b-form-feedback>
        </b-col>
      </b-row>
      <b-row v-show="this.form.tp_pagamento == 1">
        <b-col>
          <label tag="div">Tipo da Tag</label>
          <b-form-group>
            <b-form-radio-group
              v-model="form.tp_tag"
              :options="optionsTpTag"
              name="tp_tag"
              plain
              value-field="value"
            ></b-form-radio-group>
          </b-form-group>
          <b-form-feedback
            v-text="form.errors.get('tp_tag')"
            v-if="form.errors.has('tp_tag')"
          ></b-form-feedback>
        </b-col>
      </b-row>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn @click="onStore()" variant="secondary" :disabled="isDisabled">
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: ""
  },
  data() {
    return {
      dataExport: [],
      codOcorrencia: [],
      optionsTpPagamento: [
        { text: "Tag", value: 1 },
        { text: "Cartão", value: 2 }
      ],
      optionsTpTag: [
        { text: "Tag Veloe", value: 1 },
        { text: "Tag Sem Parar", value: 2 }
      ],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isFullscreen: false,
      showPopover: false,
      errors_array: [],
      rota: "",
      data: [],
      form: new Form({
        carga_id: "",
        tp_pagamento: "",
        num_cartao: "",
        tp_tag: "",
      }),
      helpForm: new Form({ statusRecord: [], params: [] }),
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    codOcorrencia(obj) {
      this.fileForm.cd_ocorrencia = obj.value;
    }
  },
  methods: {
    //mantive comentado pois n sei se haverá no futuro como fazer update
    // handleOk(e) {
    //   e.preventDefault();
    // if (this.modal_acao == "i") {
    //   this.onStore();
    // } else {
    //   this.onUpdate(this.form.feriado_id);
    // }
    // },
    onCreate(data, rota) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Informações sobre meio de pagamento Target";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.errors_array = "";
      this.rota = rota;
      this.errors_array = [];
      this.form.reset();
      this.form.carga_id = data.cargaId;
      this.$refs.modal_form.show();
    },
    // onEdit(data, index, id) {
    //   this.isDisabled = false;
    //   this.loading = false;
    //   this.modal_titulo = "Alterar";
    //   this.modal_botao = "Alterar";
    //   this.modal_acao = "u";
    //   this.form.reset();
    //   this.errors_array = "";
    //   this.errors_array = [];
    //   this.$refs.modal_form.show();
    // },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/expedicao/" + this.rota)
        .then(response => {
          new ReturnApi(response, this, true, null, null, true);
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      console.log(id);
      this.form
        .patch("/api/feriado/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
